import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";

@Component({
  selector: 'app-register-success',
  templateUrl: './register-success.component.html',
  styleUrls: ['./register-success.component.scss']
})
export class RegisterSuccessComponent extends BaseComponent implements OnInit {

  @Output() onLoginClick = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {
  }

  loginClick() {
    this.onLoginClick.emit();
  }

}
